import { inject, Pipe, PipeTransform } from '@angular/core';

import { BaasI18n } from '@lvflanders/bar';

import { DocumentModel } from '../types/dido-document-model.type';

@Pipe({
    name: 'deleteTooltip',
    standalone: true
})
export class DeleteTooltipPipe implements PipeTransform {
    readonly #i18n = inject(BaasI18n);

    transform(document: DocumentModel, extDocVerwijderenToegelaten, intern): string {
        let title = this.#i18n.get('DOMAIN_DIDO.COMMON.ACTION.DELETE');

        if (intern) {
            if (!document.actieVersnipperenToelaten) {
                if (document.status == 'AangemaaktViaEloket') {
                    title = this.#i18n.get('DOMAIN_DIDO.COMMON.ACTION.DELETE_NOT_ALLOWED_INTERN');
                }
            } else if (!document.isWriteAllowed) {
                title = this.#i18n.get('DOMAIN_DIDO.COMMON.ACTION.DELETE_NOT_ALLOWED_GEENRECHTEN');
            }
        }

        return title;
    }
}
